// extracted by mini-css-extract-plugin
module.exports = {"list":"Example_style_list__Jsq_G"};